"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgUserForwardOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M17.24 20.356c-.317.412-.303.996.052 1.36.384.392 1.022.377 1.425-.036l2.97-3.038.087-.1c.316-.412.302-.996-.053-1.359l-2.833-2.898-.093-.084c-.388-.304-.96-.262-1.332.119l-.086.099c-.317.412-.303.996.052 1.359l1.422 1.454-2.21.002h-2.82C13 17.232 13 17.97 13 18.255c0 .483.222 1.023.821 1.023l4.461.002-.956.977-.086.1z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M15.536 10.536a5 5 0 10-7.071-7.071 5 5 0 007.07 7.07zM14.12 4.879A3 3 0 119.88 9.12 3 3 0 0114.12 4.88z' }),
    react_1.default.createElement("path", { d: 'M2 20c0-4 2.001-6 6.004-6H10a1 1 0 110 2H8c-2.667 0-4 1.333-4 4h6a1 1 0 110 2H4c-1.333 0-2-.667-2-2z' }))); };
exports.default = SvgUserForwardOutline;
//# sourceMappingURL=UserForwardOutline.js.map